
import { AloDbMesureUnite } from '@/models/alodb/AloDbMesureUnite'
import { FilterBase } from '@/models/filter/FilterBase';

export interface IMesureUniteState {
    status:string
    mesureUnites: Array<AloDbMesureUnite>
    modifiedAdmMesureUnite: AloDbMesureUnite
    originalAdmMesureUnite: AloDbMesureUnite
    mesureUniteLoading: boolean
    adminFilter: FilterBase
}
  
const state:IMesureUniteState = { 
    status: '',
    mesureUnites: [],
    modifiedAdmMesureUnite: new AloDbMesureUnite(),
    originalAdmMesureUnite: new AloDbMesureUnite(),
    mesureUniteLoading:false,
    adminFilter: new FilterBase()
}
  
export default state